module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-select', {
    ref: "select",
    attrs: {
      "label": _vm.model.caption,
      "options": _vm.options,
      "select-type": _vm.selectType,
      "placeholder": _vm.param.placeholder,
      "display-value": _vm.displayValue,
      "required": _vm.param.required,
      "readonly": _vm.param.readonly,
      "disabled": _vm.param.disabled,
      "search": _vm.param.search,
      "titlewidth": _vm.titlewidth,
      "textalign": _vm.textalign
    },
    on: {
      "display-change": _vm.handleDisplayChange
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./src/components/emapm-form/emapComponents/emSelect.vue